import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { isObject, isString, logErrorAndRunFail } from '../../utils';

export interface ReportPerformanceOption {
  reportEvent: string;
  reportParams: Object;
}

// 性能指标上报
export function reportPerformance(option: ReportPerformanceOption) {
  if (!option.reportEvent || !isString(option.reportEvent)) {
    return logErrorAndRunFail(
      APINames.Native.REPORT_PERFORMANCE,
      option,
      'parameter error:  parameter.reportEvent should be String instead of Undefined.'
    );
  }
  if (!option.reportParams || !isObject(option.reportParams)) {
    return logErrorAndRunFail(
      APINames.Native.REPORT_PERFORMANCE,
      option,
      'parameter error:  parameter.reportParams should be Object instead of Undefined.'
    );
  }
  return MacleJSBridge.notifyNative(APINames.Native.REPORT_PERFORMANCE, option);
}
